/**
 * AM-026 Rule PWD-02/PWD-03 — Reset password button for admin.
 */

import { useState } from 'react';
import { useResetUserPassword } from '../api/am026';

interface ResetPasswordButtonProps {
  userId: string;
  userDisplayName: string;
}

export function ResetPasswordButton({ userId, userDisplayName }: ResetPasswordButtonProps) {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [revealedPassword, setRevealedPassword] = useState<string | null>(null);
  const { mutate, isPending, error } = useResetUserPassword(userId);

  const handleConfirmReset = () => {
    mutate(undefined, {
      onSuccess: (data) => {
        setRevealedPassword(data.generated_password);
      },
    });
  };

  const handleCloseAll = () => {
    setConfirmOpen(false);
    setRevealedPassword(null);
  };

  return (
    <>
      <button
        type="button"
        aria-label={`ریست رمز عبور ${userDisplayName}`}
        onClick={() => setConfirmOpen(true)}
      >
        🔑 ریست رمز
      </button>

      {confirmOpen && !revealedPassword && (
        <div role="dialog" aria-label="تایید ریست رمز">
          <p>
            رمز عبور «{userDisplayName}» ریست شود؟ کاربر مجبور خواهد شد در ورود
            بعدی رمز جدید را عوض کند.
          </p>
          {error && <p role="alert">خطا در ریست رمز عبور.</p>}
          <button type="button" onClick={handleCloseAll} disabled={isPending}>
            انصراف
          </button>
          <button type="button" onClick={handleConfirmReset} disabled={isPending}>
            {isPending ? 'در حال ریست...' : 'تایید ریست'}
          </button>
        </div>
      )}

      {revealedPassword && (
        <div role="dialog" aria-label="رمز عبور جدید">
          <p>رمز عبور جدید (فقط یک‌بار نمایش داده می‌شود، حتماً کپی کن):</p>
          <code data-testid="generated-password">{revealedPassword}</code>
          <button type="button" onClick={handleCloseAll}>
            بستن
          </button>
        </div>
      )}
    </>
  );
}
